import { DownloadOutlined } from '@ant-design/icons';

import { Space, Typography } from 'antd';

import { DownloadViaLink } from '../../clientUtils';

import './ReasonBanner.css';

const { Text } = Typography;

const variantBackgroundClassMapping = (variant) => {
  const map = {
    rejected: 'error',
    cancelled: 'cancelled'
  };
  return `reasonBanner-${map[variant]}-background`;
};

/**
 * varients
 * 1. cancel
 * 2. rejection
 *
 * Title
 * comment
 * file : { link: "", name: "", downloadButtonLabel : ""}
 *  */

const ReasonBanner = ({ title, comment, file, variant }) => {
  if (!title) return null;
  return (
    <div className={`reasonBanner-container ${variantBackgroundClassMapping(variant)}`}>
      <Space className="w-100" direction="vertical">
        <Space className="jc-space-between w-100">
          <Text
            className={`fw-600 ${variant === 'rejected' ? 'color-volcano' : ''}`}
            type={variant === 'rejected' && 'danger'}>
            {title}
          </Text>
        </Space>
        <Text>{comment}</Text>
        {file && file?.link ? (
          <Text
            className="action-btn"
            onClick={() => DownloadViaLink(file?.link, file?.name)}
            style={{ cursor: 'pointer' }}>
            <DownloadOutlined className="mr-8" />
            {file?.downloadButtonLabel}
          </Text>
        ) : null}
      </Space>
    </div>
  );
};

export default ReasonBanner;
